import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';

export const SHARE_REQUEST_TAGS = {
  SHARE_REQUEST: 'ShareRequest'
};

const enhancedApi = rtkAPI.enhanceEndpoints({
  addTagTypes: [SHARE_REQUEST_TAGS.SHARE_REQUEST]
});

export const shareRequestApi = enhancedApi.injectEndpoints({
  endpoints: build => ({
    listShareRequests: build.query({
      async queryFn(args) {
        const {
          indexStart = 0,
          maxResults = 10,
          sortOrder = 'CreatedDescending',
          direction = 'SENT',
          status = 'ALL',
          connectionsOnly = false
        } = args || {};

        const params = {
          indexstart: indexStart,
          maxresults: maxResults,
          order: sortOrder,
          Direction: direction,
          ...(connectionsOnly ? { connectionsonly: true } : {}),
          ...(status !== 'ALL' ? { status } : {})
        };

        try {
          const res = await api.ShareRequest.list(params);
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      keepUnusedDataFor: 60,
      providesTags: [{ type: SHARE_REQUEST_TAGS.SHARE_REQUEST, id: 'LIST' }]
    }),

    searchUserByEmail: build.mutation({
      async queryFn(email) {
        try {
          const res = await api.Users.search(email);
          return { data: res };
        } catch (error) {
          return { error };
        }
      }
    }),

    createShareRequest: build.mutation({
      async queryFn(payload) {
        try {
          const res = await api.ShareRequest.create(payload);
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: [{ type: SHARE_REQUEST_TAGS.SHARE_REQUEST, id: 'LIST' }]
    }),

    approveShareRequest: build.mutation({
      async queryFn(arg) {
        const guid = typeof arg === 'string' ? arg : arg?.guid;
        const payload = typeof arg === 'string' ? {} : arg?.payload ?? {};

        try {
          const res = await api.ShareRequest.approve(guid, payload);
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: [{ type: SHARE_REQUEST_TAGS.SHARE_REQUEST, id: 'LIST' }]
    }),

    rejectShareRequest: build.mutation({
      async queryFn(guid) {
        try {
          const res = await api.ShareRequest.reject(guid);
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: [{ type: SHARE_REQUEST_TAGS.SHARE_REQUEST, id: 'LIST' }]
    }),

    cancelShareRequest: build.mutation({
      async queryFn(guid) {
        try {
          const res = await api.ShareRequest.cancel(guid);
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: [{ type: SHARE_REQUEST_TAGS.SHARE_REQUEST, id: 'LIST' }]
    }),

    removeAssociation: build.mutation({
      async queryFn(guid) {
        try {
          const res = await api.Associations.remove(guid);
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: [{ type: SHARE_REQUEST_TAGS.SHARE_REQUEST, id: 'LIST' }]
    }),

    assignUserToLocation: build.mutation({
      async queryFn({ tenantGuid, locationGuid, userGuid }) {
        try {
          const res = await api.TenantLocations.assignUserToLocation(
            tenantGuid,
            locationGuid,
            userGuid
          );
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: [{ type: SHARE_REQUEST_TAGS.SHARE_REQUEST, id: 'LIST' }]
    })
  })
});

export const {
  useListShareRequestsQuery,
  useSearchUserByEmailMutation,
  useCreateShareRequestMutation,
  useApproveShareRequestMutation,
  useRejectShareRequestMutation,
  useCancelShareRequestMutation,
  useRemoveAssociationMutation,
  useAssignUserToLocationMutation
} = shareRequestApi;
